import api from "api";

const teams = {
    get: () => {
        return api().get('/teams')
    },

    // As permissões que uma equipe pode ter no painel, agrupadas como o menu
    // do painel, e o que cada uma já traz junto (`implications`).
    permissionsCatalog: () => {
        return api().get('/teams/permissions')
    },

    create: (payload) => {
        return api().post('/teams', payload)
    },

    update: (id, payload) => {
        return api().put(`/teams/${id}`, payload)
    },

    delete: (id) => {
        return api().delete(`/teams/${id}`)
    },

    addMember: (teamId, payload) => {
        return api().post(`/teams/${teamId}/members`, payload)
    },

    removeMember: (teamId, memberId) => {
        return api().delete(`/teams/${teamId}/members/${memberId}`)
    },

    addGrant: (teamId, payload) => {
        return api().post(`/teams/${teamId}/grants`, payload)
    },

    removeGrant: (teamId, grantId) => {
        return api().delete(`/teams/${teamId}/grants/${grantId}`)
    },
}

export default teams;
